/**
 * Akademia Universe — szkolenie użytkownika NAJEMCY (/admin/akademia).
 * ==============================================================================
 *
 * 13.09.2026 (Jan-Dar): po Genesis właściciel piekarni nie miał gdzie
 * wrócić do prezentacji modułów, a zaproszony pracownik nie miał jej wcale.
 * `/admin/akademia` przekierowywało do Akademii PARTNERA, która odmawiała
 * organizacji bez profilu partnera. Plan GENESIS_JEDNA_PRAWDA_PLAN.md §4.7:
 * te same rozdziały, postęp per osoba (`nexus_szkolenie_postep`,
 * `odbiorca: 'uzytkownik'`, migracja 691), bez materii partnerskiej.
 *
 * Najemcą jest `currentOrganization` z `useAuth()` — organizacja, w której
 * człowiek jest zalogowany, nie organizacja partnera. Rozdziały organowe
 * dostają „Skąd ta nazwa" (`modules.name_meaning_pl`) i „Co to znaczy dla
 * Was" (`genesis_narracja_modulow`) — czytane WPROST z Supabase, bo RLS
 * pozwala członkom (692, 694). Kurs jest wspólny: `KursSzkolenia`.
 */

import { useEffect, useState } from 'react';

import { KursSzkolenia, type WstawkaOrganu } from '../../components/akademia/KursSzkolenia';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../providers/AuthProvider';

import {
  zbudujWstawki,
  type WierszNarracji,
  type WierszZnaczenia,
} from './akademiaUzytkownikaCore';

export function AkademiaUzytkownikaPage() {
  const { user, currentOrganization, isLoading } = useAuth();
  const orgId = currentOrganization?.organization_id ?? null;
  const [wstawki, setWstawki] = useState<Record<string, WstawkaOrganu>>({});

  useEffect(() => {
    if (!orgId) return;
    let aktualne = true;
    void (async () => {
      const [moduly, narracje] = await Promise.all([
        supabase.from('modules').select('id,name_meaning_pl'),
        supabase
          .from('genesis_narracja_modulow')
          .select('modul,narracja_pl')
          .eq('organization_id', orgId),
      ]);
      if (!aktualne) return;
      // Brak wierszy (albo błąd RLS) = brak wstawek, nie brak kursu.
      setWstawki(
        zbudujWstawki(
          (moduly.data ?? []) as WierszZnaczenia[],
          (narracje.data ?? []) as WierszNarracji[]
        )
      );
    })();
    return () => {
      aktualne = false;
    };
  }, [orgId]);

  return (
    <KursSzkolenia
      orgId={orgId}
      ladujeKontekst={isLoading}
      userId={user?.id}
      odbiorca="uzytkownik"
      tytul="Akademia Universe"
      podtytul={`Poznaj każdy organ Universe${currentOrganization?.organization?.name ? ` — ${currentOrganization.organization.name}` : ''}; Nexus opowiada i odpowiada na pytania`}
      wyjscie="/admin"
      wstawkiOrganow={wstawki}
    />
  );
}

export default AkademiaUzytkownikaPage;
